export default {
    accountSetting: 'ตั้งค่าบัญชี',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ประวัติ',
    name: 'ชื่อ',
    surname: 'นามสกุล',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทร',
    role: 'บทบาท',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    congratulation: 'ยินดีด้วย',
    userprofileIsUpdated: 'ประวัติผู้ใช้งานถูกอัปเดตแล้ว',
    resetPassword: 'เปลี่ยนรหัสผ่าน',
    currentPassword: 'รหัสผ่านปัจจุบัน',
    placeholderCurrentPassword: 'กรุณากรอกรหัสผ่านปัจจุบัน',
    newPassword: 'รหัสผ่านใหม่',
    placeholderNewPassword: 'กรุณากรอกรหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    placeholderConfirmPassword: 'กรุณากรอกรหัสผ่านใหม่ อีกครั้ง'
}
